<script setup lang="ts"></script>

<template>
  <!-- guard margin-bottom -->
  <div>
    <p :class="$style.popup">LINEなら10秒でスタート</p>
  </div>
</template>

<style lang="scss" module>
$border-width: 2px;
$arrow-size: 12px;

$large-arrow-size: $arrow-size + ceil($border-width * 1.414);

.popup {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: $border-width solid $color-third-party-line;
  border-radius: 999em;
  margin-bottom: $large-arrow-size;
  height: 48px;
  background-color: $color-surface-primary;
  font-size: 16px;
  font-weight: bold;
  color: $color-third-party-line;

  &::before,
  &::after {
    content: '';
    position: absolute;
    display: block;
    top: 100%;
    left: 50%;
    border: solid transparent;
    width: 0;
    height: 0;
    transform: translateX(-50%);
  }

  &:before {
    border-top-color: $color-third-party-line;
    border-width: $large-arrow-size;
  }

  &:after {
    border-top-color: $color-border-high-emphasis-inverse;
    border-width: $arrow-size;
  }
}
</style>
